module.exports = __webpack_public_path__ + "img/arrow.40f7ae04.svg";